export class ButtonLink {
    id: string;
    text: string;

    constructor(json) {
        this.id = (!!json?.["id"] ? json?.["id"] : crypto.randomUUID());
        this.text = json?.["text"] ?? "";
    }
}